import React from 'react'
import { ActionButton } from '../../../../../../../components'
import { Box, Grid, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { HourglassEmptyTwoTone } from '@mui/icons-material'
import useAccountInfo from '../../../hooks/useAccountInfo'
import { useFormFactor } from '../../../../../../../hooks'

const useStyles = makeStyles(
  ({ spacing, palette, typography, breakpoints }) => ({
    root: {
      border: `1px solid ${palette.grey.shade[20]}`,
      padding: spacing(2)
    },
    title: {
      ...typography.heading.h5,
      fontWeight: typography.fontWeightBold,
      color: palette.grey.shade[90]
    },
    text: {
      ...typography.body.s,
      color: '#3a444c'
    },
    circle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      width: 56,
      height: 56,
      background: palette.secondaryGrey.shade[5],
      marginRight: 14
    },
    icon: {
      color: '#323232'
    },
    desc: {
      flex: '1 1 0'
    },
    container: {
      display: 'flex'
    },
    actionContainer: ({ isSmallScreen }) => ({
      ...(isSmallScreen && { width: '100%' })
    })
  })
)

const Suspend = ({
  onSuspend,
  'data-test': testAttr = 'retention-suspend'
}) => {
  const { accountInfoLoaded, isMonthlyPlan } = useAccountInfo()
  const { isMobile, isSmallTablet } = useFormFactor()
  const isSmallScreen = isMobile || isSmallTablet
  const classes = useStyles({ isSmallScreen })

  if (!isMonthlyPlan()) {
    return null
  }

  return (
    <Grid
      container
      alignItems='center'
      wrap={!isSmallScreen ? 'nowrap' : 'wrap'}
      spacing={2}
      className={classes.root}
      data-test={testAttr}
    >
      <Grid item xs={12} sm='auto' className={classes.container}>
        <Box className={classes.circle}>
          <HourglassEmptyTwoTone fontSize='medium' className={classes.icon} />
        </Box>
        <Box data-test={`${testAttr}-desc`} className={classes.desc}>
          <Typography data-test={`${testAttr}-title`} className={classes.title}>
            Suspend
          </Typography>
          <Typography data-test={`${testAttr}-text`} className={classes.text}>
            Suspend my subscription for 3 months
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12} sm='auto' className={classes.actionContainer}>
        <ActionButton
          variant='secondary'
          label='Suspend my subscription'
          onClick={onSuspend}
          disabled={!accountInfoLoaded}
          data-test={`${testAttr}-action`}
          size='m'
          fullWidth={isSmallScreen}
        />
      </Grid>
    </Grid>
  )
}

export default Suspend
